import { render, staticRenderFns } from "./ProductsSort.vue?vue&type=template&id=a5ede3f2&scoped=true&"
import script from "./ProductsSort.vue?vue&type=script&lang=js&"
export * from "./ProductsSort.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSort.vue?vue&type=style&index=0&id=a5ede3f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ede3f2",
  null
  
)

export default component.exports